import React, { Component } from 'react';
//import AvatarEditor from 'react-avatar-editor';
import '../css/TestimonialForm.css';
import '../css/Form.css';
import '../css/UserStyle.css'
import UserInfoRow from '../components/UserInfoRow';
import { fetchUserData } from '../../../config/UserDetailsFetch';
import { fetchUser } from '../../../config/UserDetailsPrimary';
import { Edit } from 'react-feather';
import { NavLink } from 'react-router-dom';
import Loading from '../components/Loading';
import Userimg from '../../../images/user.png';

class UserSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            image: null,
            scale: 1,
            allowZoomOut: false,
            rotate: 0,
            position: { x: 0, y: 0 },
            preview: null,
            width: 250,
            height: 250,
            user: props.user,
            joiningDate: '',
            days: 0,
            months: 0,
            years: 0,
            resignDate: null,
            userDetails: null,
            method: 'insert', // Assuming default method is 'insert'
            isLoading: false
            
        };
        this.editorRef = React.createRef();
        this.rotateInputRef = React.createRef();
        this.scaleInputRef = React.createRef();
    }

  
    
    
   

    calculateDuration = (joiningDate, resignDate) => {
        const joinDate = new Date(joiningDate);
        const specifiedDate = resignDate ? new Date(resignDate) : new Date();

        // Calculate the difference in milliseconds
        const diffTime = Math.abs(specifiedDate - joinDate);
        // Convert milliseconds to days
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        // Calculate years
        const years = Math.floor(diffDays / 365);
        // Calculate remaining days
        const remainingDays = diffDays % 365;

        // Calculate months based on remaining days
        const months = Math.floor(remainingDays / 30);
        // Calculate remaining days
        const days = remainingDays % 30;

        this.setState({ years, months, days });
       
    };
    async componentDidMount() {

        const { user } = this.props; // Extract the user prop
       
        //const userId = user.id; // Extract just the ID from the user object
        try {
          this.setState({ isLoading: true });
          const data = await fetchUser(user); // Pass only the ID to fetchUserData
    
          if (data && data.length > 0) {
            this.setState({
              userDetails: data[0], // Set userDetails state
              method: 'update' // Update method if needed
            }, () => {
                //console.log('data ssfound :', user); 
              const { userDetails } = this.state;
              const joiningDate = new Date(userDetails.join_date);
              const resignDate = userDetails.resign_date ? new Date(userDetails.resign_date) : null;
              this.setState({ joiningDate, resignDate }, () => {
                  this.calculateDuration(this.state.joiningDate, this.state.resignDate);
              });
            });
            //console.log('data found :', user); 
          } else {
            console.log('No data found for id:', user); // Log the user ID
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        } finally {
          this.setState({ isLoading: false });
        }
       

       




       
    }
   


    handleDateChange = (event) => {
        this.setState({ joiningDate: event.target.value });
    };

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleImageChange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = () => {
            this.setState({ image: reader.result }, () => {
                setTimeout(() => {
                    this.updatePreview(); // Call updatePreview after setting the image with a slight delay
                }, 100); // Adjust the delay as needed
            });
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    };


    handleZoomIn = () => {
        this.setState((prevState) => ({ scale: Math.min(prevState.scale + 0.1, 8) }), () => {
            this.updatePreview(); // Call updatePreview after zoom in
        });
        
    };

    handleZoomOut = () => {
        this.setState((prevState) => ({ scale: Math.max(prevState.scale - 0.1, 1) }), () => {
            this.updatePreview(); // Call updatePreview after zoom out
        });
    };

    handleXPosition = (e) => {
        const x = parseFloat(e.target.value);
        this.setState({ position: { ...this.state.position, x } }, () => {
            this.updatePreview(); // Call updatePreview after changing X position
        });
    };

    handleYPosition = (e) => {
        const y = parseFloat(e.target.value);
        this.setState({ position: { ...this.state.position, y } }, () => {
            this.updatePreview(); // Call updatePreview after changing Y position
        });
    };

    setEditorRef = editor => {
        if (editor) {
            this.editor = editor;
            this.updatePreview();
        }
    }

    handlePositionChange = position => {
        this.setState({ position });
    }

    rotateLeft = (e) => {
        e.preventDefault();
        this.setState({
            rotate: this.state.rotate - 90
        },
            () => {
                this.updatePreview(); // Call updatePreview after rotating left
            }
        );
    }

    rotateRight = (e) => {
        e.preventDefault();
        this.setState({
            rotate: this.state.rotate + 90
        },
            () => {
                this.updatePreview();
            }
        );
    }

    handleScale = (e) => {
        const scale = parseFloat(e.target.value);
        this.setState({ scale }, () => {
            this.updatePreview();
        });
    }

    handleRotateChange = (e) => {
        const rotate = parseFloat(e.target.value);
        this.setState({ rotate }, () => {
            this.updatePreview();
        });
    };


    updatePreview = () => {
        const img = new Image();
        img.src = this.editor.getImageScaledToCanvas().toDataURL();

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(img, 0, 0);

            const jpgImage = canvas.toDataURL('image/jpeg', 0.8);

            this.setState({
                preview: {
                    img: jpgImage,
                    scale: this.state.scale,
                    width: 250,
                    height: 250,
                }
            });
        };
    };

    handleEdit = () => {
        
        console.log('Edit button clicked');
        localStorage.setItem('postId', this.state.userDetails.id);
        localStorage.setItem('userType', this.state.userDetails.user_type);
        console.log('User Type:', this.state.userDetails.user_type);
        console.log('User ID:', this.state.userDetails.id);
      };



    render() {

       
        const {userDetails, isLoading } = this.state;
        const { joiningDate, resignDate, years, months, days } = this.state;
        
  let duration;

  if (years > 0) {
    duration = `${years} year${years > 1 ? 's' : ''}, ${months} month${months > 1 ? 's' : ''}, ${days} day${days > 1 ? 's' : ''}`;
  } else if (years == 0 && months > 0) {
    duration = `${months} month${months > 1 ? 's' : ''}, ${days} day${days > 1 ? 's' : ''}`;
  } else {
    duration = `${days} day${days > 1 ? 's' : ''}`;
  }


        return (
            

            <div>
                {isLoading ? (
          <Loading size={100} />
        ) : userDetails ? (
            <div>
                <div className="container" >
                                <div className="row mt-2" >

                                    <div className="col-md-11"></div>
                                    <div className="col-md-1 align-items-right">
                                        <div className="d-flex justify-content-start align-items-center ">
                                          
                                        <NavLink to='/user-settings/edit' label='Edit' >
        <Edit  className='ico-button' onClick={this.handleEdit}/>
    </NavLink>
                                            <span className='p-3'>  </span>

                                        </div>
                                    </div>
                                </div>
                            </div>
           
                <div className="container rounded bg-white mt-5 mb-5">
                    <div className="row">
                        <div className="col-md-3 border-right">
                            <div className="d-flex flex-column align-items-center text-center p-3 py-5">
                                <img className="rounded-circle mt-5" width="150px" src={userDetails.image_loc ? `https://yesedacademy.com/database/${userDetails.image_loc}` : Userimg} />
                                <span className="font-weight-bold">{userDetails.name}</span>
                                <span className="text-black-50">{userDetails.role}</span>
                                <span> </span>
                            </div>
                        </div>
                        <div className="col-md-5 border-right">
                            <div className="p-3 py-5">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h4 className="text-right">Personal Information</h4>
                                </div>
                                <UserInfoRow label="Full Name" value={`${userDetails.name} ${userDetails.middle_name} ${userDetails.last_name}`} />
                                <UserInfoRow label="Email" value={userDetails.personal_email} />
                                <UserInfoRow label="Mobile" value={`+${userDetails.mobile_ISD}  ${userDetails.mobile}`} />
                                <UserInfoRow label="Address" value={userDetails.address_1} />
                                <UserInfoRow value={userDetails.address_2} />
                                <UserInfoRow value={userDetails.address_3} />
                                <UserInfoRow label="City" value={userDetails.city} />
                                <UserInfoRow label="State" value={userDetails.state} />
                                <UserInfoRow label="Pincode" value={userDetails.pincode} />

                            </div>
                        </div>
                        <div className="col-md-4">
                        
                            
                            <div className="p-3 py-5">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h4 className="text-right">Job Information</h4>
                                </div>
                                <UserInfoRow label="Role" value={userDetails.role} />
                                <UserInfoRow label="Email" value={userDetails.email_address} />
                                <UserInfoRow label="Date of Joining" value={joiningDate ? joiningDate.toDateString() : ""} />
                                <UserInfoRow label="Duration" value={duration} />
                                

                                {resignDate ? <div><UserInfoRow label="Resigned Date" value={resignDate.toDateString()} /> <UserInfoRow label="Status" value="Resigned" style={{ color: 'red', '!important': true }} /></div> : <UserInfoRow label="Status" value="Currently Employed" style={{ color: 'green' }} />}
                            </div>
                        </div>
                    </div>
                </div>
                </div>
 ) : (
    <p>No data available</p>
  )}

            </div>


        );
    }
}

export default UserSettings;
